var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.333 0.333313H3.66634C1.66634 0.333313 0.333008 1.33331 0.333008 3.66665V8.33331C0.333008 10.6666 1.66634 11.6666 3.66634 11.6666H10.333C12.333 11.6666 13.6663 10.6666 13.6663 8.33331V3.66665C13.6663 1.33331 12.333 0.333313 10.333 0.333313ZM10.6463 4.39331L8.55968 6.05998C8.11967 6.41331 7.55967 6.58665 6.99967 6.58665C6.43967 6.58665 5.87301 6.41331 5.43967 6.05998L3.35301 4.39331C3.13967 4.21998 3.10634 3.89998 3.27301 3.68665C3.44634 3.47331 3.75967 3.43331 3.97301 3.60665L6.05967 5.27331C6.56634 5.67998 7.42634 5.67998 7.93301 5.27331L10.0197 3.60665C10.233 3.43331 10.553 3.46665 10.7197 3.68665C10.893 3.89998 10.8597 4.21998 10.6463 4.39331Z",
    fill: "#5C5F62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.1ee01819a3d8376b54c1732aba105dff.svg";
export { ForwardRef as ReactComponent };